import {
  all, call, fork, put, select, takeLatest,
} from 'redux-saga/effects';
import { cloneDeep, isFunction } from 'lodash';
import {
  CLOSE_COIN,
  CLOSE_MARKET,
  CREATE_MARKET,
  FETCH_COIN_SETTING,
  FETCH_INFO_ERC20,
  FETCH_TOMO_INFO_ERC20,
  FETCH_MARKET,
  OPEN_MARKET,
  OPEN_COIN,
  FETCH_ALL_COIN,
  FETCH_TOMO_COIN,
  UPDATE_COIN,
  UPDATE_LIMIT_WITHDRAWAL,
  FETCH_LIMIT_WITHDRAWAL,
  ADD_CUSTOM_ACTION,
  POST_COIN_SETTING,
  FETCH_CRYPTO_EXCHANGE_CONFIG,
  FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO,
  DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO, ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO, UPDATE_CRYPTO_EXCHANGE_CONFIG,
} from '../actions/setting_data/action_types';
import settingAction from '../actions/setting_data';
import rf from '../../requests/RequestFactory';
import actions from '../actions/admin';
import utils from '../../common/utils';

// saga effect

function* fetchToken(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('SettingRequest').getToken(params), action.params);
    yield put(settingAction.fetchInfoERC20ActionSucceed(data));
    if (isFunction(action.callback)) {
      action.callback();
    }
  } catch (err) {
    yield put(settingAction.fetchInfoERC20ActionFailed(err));
    if (isFunction(action.callback)) {
      action.callback('Không tìm thấy coin');
    }
  }
}

function* fetchTomoToken(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('SettingRequest').getTomoToken(params), action.params);
    yield put(settingAction.fetchTomoInfoERC20ActionSucceed(data));
    if (isFunction(action.callback)) {
      action.callback();
    }
  } catch (err) {
    yield put(settingAction.fetchTomoInfoERC20ActionFailed(err));
    if (isFunction(action.callback)) {
      action.callback('Không tìm thấy coin');
    }
  }
}

function* fetchMarket() {
  try {
    const { data } = yield call(() => rf.getRequest('SettingRequest').fetchMarkets());
    yield put(settingAction.fetchMarketActionSucceed(data));
  } catch (err) {
    yield put(settingAction.fetchMarketActionFailed(err));
  }
}

function* fetchCoinSettings() {
  try {
    const { data } = yield call(() => rf.getRequest('SettingRequest').fetchCoinSettings());
    yield put(settingAction.fetchCoinSettingActionSucceed(data));
  } catch (err) {
    yield put(settingAction.fetchCoinSettingActionFailed(err));
  }
}

function* createMarket(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('SettingRequest').createMarket(params), action.params);
    yield put(settingAction.createMarketActionSucceed(data));
    yield put(settingAction.fetchCoinSettingAction());
    yield action.callback();
    yield utils.showNotification('Thông báo', 'Thành công!');
  } catch (err) {
    yield action.callback();
    yield utils.showNotification('Thông báo', 'Thất bại!', 'error');
    yield put(settingAction.createMarketActionFailed(err));
  }
}

function* openMarket(action) {
  try {
    yield call((params) => rf.getRequest('SettingRequest').openMarket(params), action.params);
    yield put(settingAction.openMarketActionSucceed());
    yield put(settingAction.fetchCoinSettingAction());
  } catch (err) {
    yield put(settingAction.openMarketActionFailed(err));
  }
}

function* closeMarket(action) {
  try {
    yield call((params) => rf.getRequest('SettingRequest').closeMarket(params), action.params);
    yield put(settingAction.closeMarketActionSucceed());
    yield put(settingAction.fetchCoinSettingAction());
  } catch (err) {
    yield put(settingAction.closeMarketActionFailed(err));
  }
}

function* openCoin(action) {
  try {
    yield call((params) => rf.getRequest('SettingRequest').openCoin(params), action.params);
    yield put(settingAction.openCoinActionSucceed());
    yield put(settingAction.fetchAllCoinAction());
    utils.showNotification('Thông báo', `Mở giao dịch đồng ${action.params} thành công`, 'success');
  } catch (err) {
    yield put(settingAction.openCoinActionFailed(err));
  }
}

function* closeCoin(action) {
  try {
    yield call((params) => rf.getRequest('SettingRequest').closeCoin(params), action.params);
    yield put(settingAction.closeCoinActionSucceed());
    yield put(settingAction.fetchAllCoinAction());
    yield utils.showNotification('Thông báo', `Đóng giao dịch đồng ${action.params} thành công`, 'success');
  } catch (err) {
    yield put(settingAction.closeCoinActionFailed(err));
  }
}

function* updateCoin(action) {
  try {
    yield call((params) => rf.getRequest('SettingRequest').updateCoin(params), action.params);
    yield put(settingAction.updateCoinActionSucceed());
    yield utils.showNotification('Thông báo', 'Thành công!');
    yield put(settingAction.fetchAllCoinAction());
    yield action.callback();
  } catch (err) {
    yield action.callback();
    yield put(settingAction.closeCoinActionFailed(err));
  }
}
function* updateLimitWithdrawal(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('SettingRequest').UpdateLimitWithdrawal(params), action.params);
    yield put(settingAction.fetchAllCoinAction());
    yield action.callback();
  } catch (err) {
    yield action.callback();
    yield put(settingAction.closeCoinActionFailed(err));
  }
}

function* fetchAllCoins() {
  try {
    const { data } = yield call(() => rf.getRequest('SettingRequest').fetchAllCoins());
    yield put(settingAction.fetchAllCoinActionSucceed(data));
  } catch (err) {
    yield put(settingAction.fetchAllCoinActionFailed(err));
  }
}

function* fetchLimitWithdrawal(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('SettingRequest').fetchLimitWithdrawal(params), action.params);
    let coins = yield select((state) => state.setting.coins);
    coins = cloneDeep(coins);
    yield put(settingAction.fetchLimitWithdrawalSucceedAction(data, coins));
  } catch (err) {
    yield put(settingAction.fetchLimitWithdrawalFailedAction(err));
  }
}

function* addCustomCoin(action) {
  try {
    yield call((params) => rf.getRequest('SettingRequest').addCustomCoin(params), action.params);
    // yield put(settingAction.addCustomCoinActionSucceed(data));
    yield put(settingAction.fetch());
  } catch (err) {
    console.log(err, ': err src/redux/sagas/setting_saga.js:137');
    yield put(settingAction.addCustomCoinActionFailed(err));
  }
}

function* addCoin(action) {
  try {
    yield call((params) => rf.getRequest('SettingRequest').postCoinSetting(params), action.params);
    yield put(settingAction.postCoinSettingSucceed());
  } catch (err) {
    yield put(settingAction.postCoinSettingFailed(err));
  }
}

function* fetchTomoCoin(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('SettingRequest').fetchTomoCoin(params), action.params);
    yield put(settingAction.fetchTomoCoinActionSucceed());
  } catch (err) {
    yield put(settingAction.fetchTomoCoinActionFailed(err));
  }
}

function* fetchCryptoExchangeConfig(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('SettingRequest').fetchCryptoExchangeConfig(params), action.params);
    // yield put(settingAction.addCustomCoinActionSucceed(data));
    yield put(settingAction.fetchCryptoExchangeConfigActionSucceed(data));
  } catch (err) {
    console.log(err, ': err src/redux/sagas/setting_saga.js:137');
    yield put(settingAction.fetchCryptoExchangeConfigActionFailed(err));
  }
}

function* updateCryptoExchangeConfig(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('SettingRequest').updateCryptoExchangeConfig(params), action.params);
    // yield put(settingAction.addCustomCoinActionSucceed(data));
    if (isFunction(action.callback)) {
      yield action.callback();
    }
    yield put(settingAction.updateCryptoExchangeConfigActionSucceed(data));
  } catch (err) {
    console.log(err, ': err src/redux/sagas/setting_saga.js:137');
    yield put(settingAction.updateCryptoExchangeConfigActionFailed(err));
  }
}

function* fetchListPublicKeyActiveListCrypto(action) {
  try {
    const { total, data } = yield call((params) => rf.getRequest('SettingRequest').fetchListPublicKeyActiveListCrypto(params), action.params);
    // yield put(settingAction.addCustomCoinActionSucceed(data));
    if (isFunction(action.callback)) {
      yield action.callback(total, data);
    }
    yield put(settingAction.fetchListPublicKeyActiveListCryptoActionSucceed(data));
  } catch (err) {
    console.log(err, ': err src/redux/sagas/setting_saga.js:137');
    yield put(settingAction.fetchListPublicKeyActiveListCryptoActionFailed(err));
  }
}

function* deletePublicKeyActiveListCrypto(action) {
  try {
    yield call((params) => rf.getRequest('SettingRequest').deletePublicKeyActiveListCrypto(params), action.params);
    if (isFunction(action.callback)) {
      yield action.callback();
    }
    yield put(settingAction.deletePublicKeyActiveListCryptoActionSucceed());
  } catch (err) {
    console.log(err, ': err src/redux/sagas/setting_saga.js:137');
    yield put(settingAction.deletePublicKeyActiveListCryptoActionFailed(err));
  }
}

function* addPublicKeyToActiveListCrypto(action) {
  try {
    yield call((params) => rf.getRequest('SettingRequest').addPublicKeyToActiveListCrypto(params), action.params);
    if (isFunction(action.callback)) {
      yield action.callback();
    }
    yield put(settingAction.addPublicKeyToActiveListCryptoActionSucceed());
  } catch (err) {
    console.log(err, ': err src/redux/sagas/setting_saga.js:137');
    yield put(settingAction.addPublicKeyToActiveListCryptoActionFailed(err));
  }
}

function* watchSettings() {
  yield takeLatest(FETCH_INFO_ERC20, fetchToken);
  yield takeLatest(FETCH_TOMO_INFO_ERC20, fetchTomoToken);
  yield takeLatest(CREATE_MARKET, createMarket);
  yield takeLatest(OPEN_MARKET, openMarket);
  yield takeLatest(CLOSE_MARKET, closeMarket);
  yield takeLatest(FETCH_MARKET, fetchMarket);
  yield takeLatest(FETCH_COIN_SETTING, fetchCoinSettings);
  yield takeLatest(OPEN_COIN, openCoin);
  yield takeLatest(CLOSE_COIN, closeCoin);
  yield takeLatest(FETCH_ALL_COIN, fetchAllCoins);
  yield takeLatest(FETCH_TOMO_COIN, fetchTomoCoin);
  yield takeLatest(UPDATE_COIN, updateCoin);
  yield takeLatest(UPDATE_LIMIT_WITHDRAWAL, updateLimitWithdrawal);
  yield takeLatest(FETCH_LIMIT_WITHDRAWAL, fetchLimitWithdrawal);
  yield takeLatest(ADD_CUSTOM_ACTION, addCustomCoin);
  yield takeLatest(POST_COIN_SETTING, addCoin);
  yield takeLatest(FETCH_CRYPTO_EXCHANGE_CONFIG, fetchCryptoExchangeConfig);
  yield takeLatest(UPDATE_CRYPTO_EXCHANGE_CONFIG, updateCryptoExchangeConfig);
  yield takeLatest(FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO, fetchListPublicKeyActiveListCrypto);
  yield takeLatest(DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO, deletePublicKeyActiveListCrypto);
  yield takeLatest(ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO, addPublicKeyToActiveListCrypto);
}

export default function* rootSaga() {
  yield all([fork(watchSettings)]);
}
